import React from 'react';
import { domainLogo, domainLogoAlt } from '../domain-logo';
import { usePoweredByBranding } from '../../hooks/usePoweredByBranding';

interface RedirectHeaderProps {
  className?: string;
}

export const RedirectHeader: React.FC<RedirectHeaderProps> = ({ className = '' }) => {
  const { enabled: poweredByEnabled, clientLogoUrl } = usePoweredByBranding();
  const logoSrc = poweredByEnabled && clientLogoUrl ? clientLogoUrl : domainLogo;
  const logoAlt = poweredByEnabled && clientLogoUrl ? 'Client logo' : domainLogoAlt;

  return (
    <header
      className={`flex h-20 w-full items-center justify-center border-b border-gray-100 bg-white px-6 ${className}`}
    >
      <div className="flex items-center justify-center">
        <img src={logoSrc} alt={logoAlt} className="h-8 w-auto max-w-[220px] object-contain" />
      </div>
    </header>
  );
};
